// extracted by mini-css-extract-plugin
var _1 = "EpostFormCalculatedTable-moduleEpostFormCalculatedTable__IDNJV";
var _2 = "EpostFormCalculatedTable-moduleEpostFormCalculatedTableHeader__WVjLQ";
var _3 = "EpostFormCalculatedTable-moduleEpostFormCalculatedTableRow__Sh7hZ";
var _4 = "EpostFormCalculatedTable-moduleheaderText__S_Prz";
var _5 = "EpostFormCalculatedTable-moduleloader__hHl_p";
var _6 = "EpostFormCalculatedTable-modulenotEnoughCredits__qtnR0";
export { _1 as "EpostFormCalculatedTable", _2 as "EpostFormCalculatedTableHeader", _3 as "EpostFormCalculatedTableRow", _4 as "headerText", _5 as "loader", _6 as "notEnoughCredits" }
